module.exports = __webpack_public_path__ + "img/deshadow-after.d8b83b46.webp";